import { QueryClient } from '@tanstack/react-query';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';

import { BreadcrumbProvider } from '~/context/BreadcrumbProvider';
import type { AuthContextType } from '~/context/types';

export interface RouterContext {
	getTitle: string | undefined;
	queryClient: QueryClient;
	auth: AuthContextType;
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => (
		<BreadcrumbProvider>
			<Outlet />
		</BreadcrumbProvider>
	)
});
